declare global {
  interface Window {
    ENV?: {
      REACT_APP_POSTHOG_KEY?: string;
    };
  }
}

/** Runtime secret from env-config.js (prod) with process.env fallback for local dev. */
export function getPostHogKey(): string {
  return (
    window.ENV?.REACT_APP_POSTHOG_KEY ?? process.env.REACT_APP_POSTHOG_KEY ?? ""
  );
}

export {};
